import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { formatPrice } from "../lib/api";

const BundlesSection = ({ bundles = [] }) => {
  return (
    <section className="bg-bone border-y border-line" data-testid="bundles-section">
      <div className="container-x py-20 md:py-28">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 mb-12">
          <div className="md:col-span-7">
            <p className="overline mb-4">Bundles</p>
            <h2 className="font-display uppercase text-4xl md:text-6xl tracking-tightest font-bold leading-[0.95]">
              Built for matchday,
              <br />
              training and <span className="text-mute">rotation.</span>
            </h2>
          </div>
          <div className="md:col-span-5 flex md:items-end">
            <p className="text-mute max-w-md leading-relaxed">
              Three launch packs designed around how footballers actually rotate pitch wear across a
              season — match, train, recover, repeat.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-line border border-line">
          {bundles.map((b, idx) => (
            <article
              key={b.slug}
              className="bg-white p-8 md:p-10 flex flex-col"
              data-testid={`bundle-${b.slug}`}
            >
              <div className="flex items-center justify-between mb-6">
                <span className="mono text-xs text-mute">0{idx + 1} · {b.pairs} pair{b.pairs > 1 ? "s" : ""}</span>
                <span
                  className={`mono text-[10px] tracking-widest uppercase px-2 py-1 border ${
                    idx === 1
                      ? "bg-ink text-white border-ink"
                      : idx === 2
                      ? "bg-pritch-volt-trim border-pritch-volt-trim text-ink"
                      : "border-line text-mute"
                  }`}
                >
                  {b.tag}
                </span>
              </div>

              <h3 className="font-display uppercase text-3xl md:text-4xl tracking-tightest font-bold leading-[1]">
                {b.name}
              </h3>
              <p className="text-sm text-mute mt-4 leading-relaxed flex-1">{b.description}</p>

              <div className="mt-8 flex items-end justify-between border-t border-line pt-6">
                <div>
                  <p className="font-display text-3xl">{formatPrice(b.price)}</p>
                  {b.saving > 0 && (
                    <p className="mono text-xs text-mute mt-1">Save {formatPrice(b.saving)}</p>
                  )}
                </div>
                <Link
                  to={`/product/pritch-grip-sock?pack=${b.slug}`}
                  className="inline-flex items-center gap-2 text-[11px] tracking-[0.18em] uppercase font-bold hover:gap-3 transition-all"
                  data-testid={`bundle-cta-${b.slug}`}
                >
                  Build pack <ArrowRight size={14} />
                </Link>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BundlesSection;
